document.addEventListener('DOMContentLoaded', function () {
  function initMobileSliders() {
    if (window.innerWidth > 749) return;

    document.querySelectorAll('product-card-image-slider').forEach(function (slider) {
      if (slider.dataset.mobileFixed === 'true') return;
      slider.dataset.mobileFixed = 'true';

      var track = slider.querySelector('.slider');
      var items = slider.querySelectorAll('.slider__item');
      if (!track || items.length < 2) return;

      var prevBtn = slider.querySelector('.slider-nav__btn[name="prev"]');
      var nextBtn = slider.querySelector('.slider-nav__btn[name="next"]');

      function currentIndex() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function scrollToIndex(i) {
        var item = items[i];
        if (item) {
          track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          scrollToIndex(Math.max(0, currentIndex() - 1));
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          scrollToIndex(Math.min(items.length - 1, currentIndex() + 1));
        });
      }
    });
  }

  initMobileSliders();
  document.addEventListener('shopify:section:load', initMobileSliders);
});